<template>
  <div class="header-wrapper">
    <div class="header-container">
      <div class="brand" @click="goIndex">
        <span class="brand-mark">
          <img src="../assets/logo.png" class="logo-img" alt="Let's SSL"/>
        </span>
        <span class="brand-text">
          <span class="brand-name">Let's SSL</span>
          <span class="brand-tag">Free ACME certificates</span>
        </span>
      </div>
      <nav class="header-actions">
        <el-button
          v-if="status==='authed'&&isDashboard()===false"
          type="text"
          class="text-btn"
          icon="el-icon-s-grid"
          @click="goUser">
          Dashboard
        </el-button>
        <el-button
          v-if="status==='anon'&&isLogin()===false"
          type="primary"
          class="header-btn"
          @click="goLogin">
          Sign in
        </el-button>
        <el-button
          v-if="status==='authed'&&isDashboard()===true"
          type="text"
          class="text-btn danger"
          icon="el-icon-switch-button"
          @click="logout">
          Logout
        </el-button>
      </nav>
    </div>
  </div>
</template>

<script>
import service from "@/util/request";
import * as api from "@/util/api";
import notify from "@/util/notify";
import { session, markAnon } from "@/util/session";

export default {
  name: 'Header',
  computed: {
    // Session state comes from the cookie check (see util/session.js), not from localStorage:
    // a stale localStorage entry used to keep "Dashboard"/"Logout" visible on dead sessions.
    status() {
      return session.status;
    },
  },
  methods: {
    goLogin() {
      if (this.$route.path !== '/login') {
        this.$router.push({path: '/login'});
      }
    },
    goUser() {
      if (this.$route.path !== '/dashboard') {
        localStorage.removeItem('order');
        this.$router.push({path: '/dashboard'});
      }
    },
    goIndex() {
      if (this.$route.path !== '/') {
        this.$router.push({path: '/'});
      }
    },
    isDashboard() {
      return this.$route.path === '/dashboard';
    },
    isLogin() {
      return this.$route.path === '/login';
    },
    logout() {
      service.get(api.logout).then(() => {
        notify.success('Signed out.');
        markAnon();
        localStorage.removeItem('order');
        this.$router.push('/');
      }).catch(() => {});
    }
  }
}
</script>

<style lang="scss" scoped>
.header-wrapper {
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid #e6eaf3;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.header-container {
  max-width: 1140px;
  margin: 0 auto;
  padding: 0 20px;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  min-width: 0;
}

/* Icon sits in a small gradient square, reads more like a brand mark than a bare image */
.brand-mark {
  width: 40px;
  height: 40px;
  flex: none;
  border-radius: 12px;
  background: var(--brand-grad);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 18px rgba(99, 102, 241, 0.28);

  .logo-img {
    width: 24px;
    height: 24px;
    filter: brightness(0) invert(1);
  }
}

.brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  min-width: 0;
}

.brand-name {
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #1c2536;
  white-space: nowrap;
}

.brand-tag {
  font-size: 12px;
  color: #94a3b8;
  white-space: nowrap;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: none;
}

.text-btn {
  font-size: 14px;
  font-weight: 600;
  color: #56637a;
  padding: 8px 10px;

  &:hover {
    color: #409eff;
    background: #f2f7ff;
  }

  &.danger:hover {
    color: #dc4b4b;
    background: #fdecec;
  }
}

.header-btn {
  font-size: 14px;
  padding: 11px 22px;
}

@media screen and (max-width: 768px) {
  .header-container {
    height: 60px;
    padding: 0 14px;
  }

  .brand-mark {
    width: 34px;
    height: 34px;
    border-radius: 10px;

    .logo-img {
      width: 20px;
      height: 20px;
    }
  }

  .brand-name {
    font-size: 16px;
  }

  .brand-tag {
    display: none;
  }

  .text-btn {
    padding: 6px;
  }
}
</style>